import { ProvenanceInfo } from 'types/provenance';

export function getFilteredProvenance(): ProvenanceInfo | undefined {
    const params = new URLSearchParams(window.location.search);
    const provenanceInfo: ProvenanceInfo = {
        utmSource: params.get('utm_source'),
        utmMedium: params.get('utm_medium'),
        utmCampaign: params.get('utm_campaign')
    };

    const filteredProvenance = Object.fromEntries(Object.entries(provenanceInfo).filter(([, value]) => !!value));

    return Object.keys(filteredProvenance).length > 0 ? filteredProvenance : undefined;
}
